import { Pagination,Table } from "antd";
import { getLeaveType } from 'api/services/common';
import { getLeavesApi } from "api/services/employee";
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { formatDateHandler2 } from "utils/common";
import { defaultPagination,handlePageChange,itemRender,pageSizeOptions } from "utils/table";
import EmployeeLeaveModelPopup from "../../components/modelpopup/EmployeeLeaveModelPopup";

import { SkeltonLoader } from "components/skeltonLoader";
import { useMediaQuery } from "react-responsive";

import { Button } from "components/Button";




const EmployeeLeave = ({filters, userData}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [selectedLeave, setSelectedLeave] = useState("");
  const [leaveModal, setLeaveModal] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [expandedComments, setExpandedComments] = useState({});

    const [leaves, setLeaves] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageSettings , setPageSettings] = useState({
      ...defaultPagination,
        sortType: "asc",
        sortBy: "leave_type__code"
      })

    useEffect(()=>{
      console.log(userData, "KKKKKKK")
      if(userData?.id){
       
      setLoading(true)
      fetchLeaveList()
      }

    },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, userData])
    useEffect(()=>{
      getLeaveType().then(res=>{
        setLeaveTypes(res.data.results.map(item=>{
          return{
            label: `${item.code} - ${item.description}`,
            value: item.id,
            code: item.code // Preserve code for filtering/disabled logic
          }
        }))
      })
    },[])
    const fetchLeaveList = () => {
      let params = {
        // user: userData?.id,
        sort_by: pageSettings?.sortBy,
        sort_type: pageSettings?.sortType,
        page_size: pageSettings?.pageSize,
        page: pageSettings?.page,
        company_user: userData?.id,
        approval_status: "all"
    }

      getLeavesApi(params).then(response=>{
        setLeaves(response.data.results)
        setLoading(false)
        setPageSettings((prev) => ({
            ...prev,
            total: response.data.count
        }))
    })
    }

    const handleChange = (pagination, filters, sorter) =>{
        let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
        setPageSettings(pageData)
    }

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leave_type",
      render: (text, record) =>
        <Link to="#" className="cursor-pointer"
      style={{
       cursor: "pointer !important",
      }}

      onClick={()=>{
        setSelectedLeave(record)
        setLeaveModal(true)
      }}>
          {record?.leave_type?.description}
           </Link>
        ,
      sorter: false,
    },
    // {
    //     title: "Leave Code",
    //     dataIndex: "leave_type__code",
    //     render: (text, record) => <span>{record?.leave_type?.code}</span>,
    //     sorter: true,
    //   },
    {
      title: "From",
      dataIndex: "start_date",
      render: (text, record) => <span>{formatDateHandler2(record?.start_date)}</span>,

      sorter:   true,
    },
    {
      title: "To",
      dataIndex: "end_date",
      render: (text, record) => <span>{formatDateHandler2(record?.end_date)}</span>,

      sorter: true,
    },

    {
      title: "Days",
      dataIndex: "no_of_days",
      render: (text, record) => <span>{text}</span>,
      sorter: true,
    },

    {
      title: "Reason",
      dataIndex: "comment",
      width: 300,
      sorter: true,
      render: (text, record) => {
        if (!text || text.trim() === "") {
          return <span></span>;
        }
        
        const isExpanded = expandedComments[record.id];
        const maxLength = 100;
        const shouldTruncate = text && text.length > maxLength;
        const displayText = isExpanded || !shouldTruncate ? text : `${text.substring(0, maxLength)}...`;
        
        return (
          <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
              <span
                style={{
                  flex: 1,
                  whiteSpace: isExpanded ? "pre-wrap" : "normal",
                  wordBreak: "break-word",
                  overflow: isExpanded ? "visible" : "hidden",
                  textOverflow: isExpanded ? "clip" : "ellipsis",
                  lineHeight: "1.5",
                  display: isExpanded ? "block" : "-webkit-box",
                  WebkitLineClamp: isExpanded ? "none" : 3,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {displayText}
              </span>
              {shouldTruncate && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpandedComments(prev => ({
                      ...prev,
                      [record.id]: !prev[record.id]
                    }));
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#667eea",
                    cursor: "pointer",
                    padding: "4px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    borderRadius: "4px",
                    transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(102, 126, 234, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                  title={isExpanded ? "Collapse" : "Expand"}
                >
                  <i className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                </button>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-${ text == "pending" ?  "warning" : text == "rejected" ? "danger" : "success"}`}>{text}</span>  

          {/* <Link
            className="btn btn-white btn-sm btn-rounded dropdown-toggle"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              className={
                text === "new"
                  ? "far fa-dot-circle text-purple"
                  : text === "pending"
                  ? "far fa-dot-circle text-info"
                  : text === "approved"
                  ? "far fa-dot-circle text-success"
                  : "far fa-dot-circle text-danger"
              }
            />{" "}
            {text}
          </Link>

          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-purple" /> New
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-info" /> Pending
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-success" /> Approved
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-danger" /> Declined
            </Link>
          </div> */}
        </div>
      ),
    },
    {
        title: "Approved On",
        dataIndex: "approved_on",
        render: (text) => <>{formatDateHandler2(text)}</>,
        // render: (text, record) => <div>
        //      <Link  to={`/employees/${record?.approved_by?.id}`}>
        //      {record?.approved_by?.first_name} {record?.approved_by?.last_name}
        //     </Link>
        // <br/>
        // <small>{record?.approved_by?.email}</small>
        // </div> ,
  
        sorter: true,
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        sorter: true,
        render: (text) => <>{formatDateHandler2(text)}</>,
      },
      {
        title: "Updated At",
        dataIndex: "updated_at",
        sorter: true,
        render: (text) => <>{formatDateHandler2(text)}</>,
      },
    {
      title: "Action",
      className: "text-end",
      sorter: false,
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_leave"
              onClick={()=>{
                setSelectedLeave(record)
                setLeaveModal(true)
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  const leaveStats = [
    {
      id: 1,
      title: "Annual Leave",
      value: 12,
    },
    {
      id: 2,
      title: "Medical Leave",
      value: 3,
    },
    {
      id: 3,
      title: "Other Leave",
      value: 4,
    },
    {
      id: 4,
      title: "Remaining Leave",
      value: 5,
    },
  ];

  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
					
  }

  const EmptyState = () => (
    <div className="col-12" style={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: isMobile ? "60px 20px" : "80px 40px",
      textAlign: "center"
    }}>
      <div style={{
        width: isMobile ? "120px" : "150px",
        height: isMobile ? "120px" : "150px",
        marginBottom: "24px",
        opacity: 0.6
      }}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4Z" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 2V6" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 2V6" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 10H21" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h3 style={{ 
        fontSize: isMobile ? "18px" : "20px", 
        fontWeight: "600", 
        color: "#1f2937",
        marginBottom: "8px"
      }}>
        No Leave Records Found
      </h3>
      <p style={{ 
        fontSize: isMobile ? "14px" : "15px", 
        color: "#6b7280",
        margin: 0,
        maxWidth: "400px"
      }}>
        This employee doesn't have any leave records yet.
      </p>
    </div>
  );

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else if (leaves.length === 0) {
      return <EmptyState />;
    } else {
      return (
        <>
          {leaves.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6" key={record.id} style={isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : {}}>
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: isMobile ? 0 : "0 0 20px 0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer"
              }}
              onClick={() => {
                setSelectedLeave(record)
                setLeaveModal(true)
              }}
              >
                <div style={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  zIndex: 10
                }}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedLeave(record);
                      setLeaveModal(true);
                    }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#ffffff",
                      textDecoration: "none",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                    }}
                  >
                    <i className="fa fa-pencil" style={{ fontSize: "12px" }}></i>
                  </Link>
                </div>
                <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
                  {record?.leave_type?.description && (
                    <div style={{ marginBottom: "16px" }}>
                      <span className={`badge badge-soft-${record?.approval_status === "pending" ? "warning" : record?.approval_status === "rejected" ? "danger" : "success"}`} style={{
                        fontSize: "11px",
                        padding: "4px 8px",
                        borderRadius: "4px"
                      }}>
                        {record?.leave_type?.description}
                      </span>
                    </div>
                  )}
                  
                  <div style={{
                    borderTop: record?.leave_type?.description ? "1px solid #e5e7eb" : "none",
                    paddingTop: record?.leave_type?.description ? "12px" : "0"
                  }}>
                    <div className="row g-2" style={{ marginBottom: "10px" }}>
                      <div className="col-6">
                        <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                          <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                          From
                        </div>
                        <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                          {formatDateHandler2(record.start_date)}
                        </div>
                      </div>
                      <div className="col-6">
                        <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                          <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                          To
                        </div>
                        <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                          {formatDateHandler2(record.end_date)}
                        </div>
                      </div>
                      <div className="col-6">
                        <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                          <i className="la la-calendar-week" style={{ marginRight: "4px" }}></i>
                          Days
                        </div>
                        <div style={{ fontSize: "12px", color: "#374151", fontWeight: "600" }}>
                          {record.no_of_days} {record.no_of_days === 1 ? "day" : "days"}
                        </div>
                      </div>
                      <div className="col-6">
                        <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                          Status
                        </div>
                        <div>
                          <span className={`badge badge-soft-${record?.approval_status === "pending" ? "warning" : record?.approval_status === "rejected" ? "danger" : "success"}`} style={{
                            fontSize: "11px",
                            padding: "4px 8px",
                            borderRadius: "4px"
                          }}>
                            {record?.approval_status || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    {record?.comment && (
                      <div style={{ 
                        marginTop: "10px",
                        paddingTop: "10px",
                        borderTop: "1px solid #e5e7eb"
                      }}>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#9ca3af", 
                          marginBottom: "4px",
                          fontWeight: "500"
                        }}>
                          Reason
                        </div>
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#374151",
                          lineHeight: "1.5",
                          wordBreak: "break-word"
                        }}>
                          {record.comment}
                        </div>
                      </div>
                    )}
                    
                    {record?.approved_on && (
                      <div style={{ 
                        marginTop: "8px",
                        fontSize: "11px",
                        color: "#9ca3af"
                      }}>
                        <i className="la la-check-circle" style={{ marginRight: "4px" }}></i>
                        Approved on {formatDateHandler2(record.approved_on)}
                      </div>
                    )}
                    </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };
  
  return (
    <>
      {isMobile ? (
        <div className="row" style={{ marginLeft: "8px", marginRight: "8px" }}>    
          {!loading && leaves.length === 0 ? (
            <EmptyState />
          ) : (
            <GridView />
          )}
          {leaves.length > 0 && (
            <div className="my-2 d-flex justify-content-end ">
              <div className="col-sm-12 col-md-6 ">
                <Pagination
                  pageSize={pageSettings?.pageSize}
                  pageSizeOptions={pageSizeOptions}
                  defaultCurrent={1}
                  current={pageSettings?.page}
                  total={pageSettings?.total}
                  // itemRender={itemRender}
                  onChange={handleGridChange}
                  showLessItems
                  showSizeChanger={false}
                  showQuickJumper={false}
                  hideOnSinglePage
                  itemRender={(page, type, originalElement) => {
                    if (type === "next") {
                      return (
                        <Button
                          loading={loading}
                          // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                          className="btn btn-primary "
                          // type="Load More"
                          label="Load More"
                        />
                      );
                    }
                    return null;
                  }}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="row">
          <div className="col-12">
            {!loading && leaves.length === 0 ? (
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <EmptyState />
              </div>
            ) : (
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <style>{`
                  .modern-table .ant-table-tbody > tr {
                    background-color: #ffffff !important;
                  }
                  .modern-table .ant-table-tbody > tr:hover > td {
                    background-color: #f5f5f5 !important;
                  }
                  .modern-table .ant-table-thead > tr > th {
                    background-color: #f8f9fa !important;
                    font-weight: 600;
                    color: #333;
                    border-bottom: 2px solid #e0e0e0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-tbody > tr > td {
                    border-bottom: 1px solid #f0f0f0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                    border-top: 1px solid #f0f0f0;
                    background-color: #ffffff;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  }
                `}</style>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                    className="mb-0 modern-table"
                    style={{ 
                      borderRadius: "12px",
                      minWidth: "100%"
                    }}
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    dataSource={leaves}
                    rowKey={(record) => record.id}
                    loading={loading}
                    pagination={{
                      total: pageSettings?.total,
                      pageSize: pageSettings?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: pageSizeOptions,
                      itemRender: itemRender,
                      position:"right",
                      current:pageSettings?.page,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                      style: { padding: "16px" }
                    }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <EmployeeLeaveModelPopup fetchLeaveList={fetchLeaveList} selectedLeave={selectedLeave} setSelectedLeave={setSelectedLeave} leaveTypes={leaveTypes} leaveModal={leaveModal} setLeaveModal={setLeaveModal} />
    </>
  );
};

export default EmployeeLeave;
